/** @typedef {{ apiBaseUrl?: string, auth0Domain?: string, auth0ClientId?: string, auth0Audience?: string, auth0RedirectUri?: string }} CalcPublicConfig */

function pub() {
  if (typeof window === 'undefined') return /** @type {CalcPublicConfig} */ ({});
  return window.__CALC_PUBLIC_CONFIG__ || {};
}

function pubString(key) {
  const v = pub()[key];
  return typeof v === 'string' && v.trim() !== '' ? v : undefined;
}

/** API origin or '' for same-origin (nginx → /api/* → Go). */
export function calcApiBase() {
  const runtime = pub();
  if (Object.prototype.hasOwnProperty.call(runtime, 'apiBaseUrl') && typeof runtime.apiBaseUrl === 'string') {
    return runtime.apiBaseUrl.trim().replace(/\/$/, '');
  }
  const v = process.env.REACT_APP_API_BASE_URL;
  if (v !== undefined && String(v).trim() !== '') return String(v).replace(/\/$/, '');
  return 'http://localhost:8080';
}

export function calcAuth0Domain() {
  return pubString('auth0Domain') || process.env.REACT_APP_AUTH0_DOMAIN || '';
}

export function calcAuth0ClientId() {
  return pubString('auth0ClientId') || process.env.REACT_APP_AUTH0_CLIENT_ID || '';
}

export function calcAuth0Audience() {
  return pubString('auth0Audience') || process.env.REACT_APP_AUTH0_AUDIENCE || '';
}

export function calcAuth0RedirectUri() {
  return pubString('auth0RedirectUri') || process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin;
}
